import _ from "lodash";
import { FaFileDownload } from "react-icons/fa";
import { IconButton } from "@mui/material";
import { NFSeState } from "store/reducers/nfse";
import { State } from "store/reducers";
import { useDispatch, useSelector } from "react-redux";
import actions from "store/actions";
import Spinner from "Components/Spinner";
import Tooltip from "Components/Tooltip";

let downloadNFSesDebounced: (() => any) & _.Cancelable = _.debounce(
	() => {},
	250
);

interface Props {
	tableState: any;
	enhancedCallback?: (result: any) => void;
}

function DownloadNFSes({ tableState, enhancedCallback }: Props) {
	const dispatch = useDispatch<any>();

	const { loading } = useSelector<State, NFSeState>(s => s.nfse);

	const handleDownloadNFSes = () => {
		const { pages, pageSize, sorted, filtered, callback } = tableState;

		if (downloadNFSesDebounced) {
			downloadNFSesDebounced.cancel();
		}

		if (!tableState.sorted) {
			tableState.sorted = [];
		}

		const createdAt = tableState.filtered.find(
			(c: any) => c.id === "createdAt"
		);

		if (createdAt?.value) {
			tableState.filtered = tableState.filtered.filter(
				(c: any) => c.id !== "createdAt"
			);

			if (createdAt?.value.startDate) {
				tableState.filtered.push({
					id: "startDate",
					value: createdAt.value.startDate
				});
			}

			if (createdAt?.value.endDate) {
				tableState.filtered.push({
					id: "endDate",
					value: createdAt.value.endDate
				});
			}
		}

		downloadNFSesDebounced = _.debounce(
			() =>
				dispatch(
					actions.nfse.downloadNFSes(
						tableState.filtered.reduce(
							(p: any, c: any) => p + `&filters[${c.id}]=${c.value}`,
							""
						),
						enhancedCallback || callback
					)
				),
			500
		);

		downloadNFSesDebounced();
	};

	return (
		<div>
			{loading.download ? (
				<Spinner size={24} />
			) : (
				<Tooltip title="Baixar arquivos das notas fiscais">
					<IconButton onClick={handleDownloadNFSes}>
						<FaFileDownload />
					</IconButton>
				</Tooltip>
			)}
		</div>
	);
}

export default DownloadNFSes;
